import { createContext, useContext } from 'react'
import { CountTypeStrings } from 'enums/CountType'

interface WidgetSettingContext {
  countType: CountTypeStrings
  maxSoundbites: number
}

const widgetSettingContext = createContext<Partial<WidgetSettingContext>>({})
export default widgetSettingContext

export const useWidgetSettingContext = () =>
  useContext(widgetSettingContext) as WidgetSettingContext
